import { FileIconType, getFileTypeIconAsUrl, IFileTypeIconOptions } from "@fluentui/react-file-type-icons";
import { IGraphCreateShareableLinkRequest, ShareableLinkRequestScope, ShareableLinkRequestType } from "../../src/taskpane/components/_v2/redux/api/graph/api-graph-interfaces";
import { createItemShareableLink, getItemThumbnail } from "../../src/taskpane/services/GraphService";
import { getExtension } from "../../src/taskpane/components/helpers/stringHelper";
import { SharePointFolderContentTypeIds } from "../../src/taskpane/config/constants";
import { ICardRequest } from "../../src/taskpane/interfaces/ICardRequest";
import * as microsoftTeams from '@microsoft/teams-js'

const shareToTeams = async (driveId, itemId, isDocument, fileName, contentTypeId, webUrl) => {

    const sharedLinkRequest: IGraphCreateShareableLinkRequest = {
        driveId: driveId,
        itemId: itemId,
        type: ShareableLinkRequestType.View,
        scope: ShareableLinkRequestScope.Anonymous
    };

    const [createLinkResult, thumbNailResult] = await Promise.all([
        createItemShareableLink(sharedLinkRequest),
        getItemThumbnail(driveId, itemId)
    ]);

    const iconType: IFileTypeIconOptions = isDocument
        ? { extension: getExtension(fileName), size: 32, imageFileType: "png" }
        : { type: contentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet) ? FileIconType.docset : FileIconType.folder, size: 32, imageFileType: "png" };

    const taskRequest: ICardRequest = {
        fileName: fileName,
        url: createLinkResult?.link?.webUrl ?? webUrl,
        iconUrl: getFileTypeIconAsUrl(iconType),
        thumbUrl: thumbNailResult?.url,
    };

    microsoftTeams.getContext((context) => {
        if (context.frameContext === "content") {
            microsoftTeams.sharing.shareWebContent({
                content: [
                    {
                        type: "URL",
                        url: `${createLinkResult?.link?.webUrl ?? webUrl}`,
                        // message: 'Send as Message',
                        preview: true
                    }
                ]
            });
        } else if (context.frameContext === "task") {
            microsoftTeams.tasks.submitTask(taskRequest);
        }
    });
}

export default shareToTeams;